import React from "react";
import { isSet } from "../../../../../../utils/commonUtils";

const InlineValueText = ({
  col = "col-12",
  labelPrefix = "Printed Name",
  valueField = "",
  showWhenField = "",
  formData = {},
}) => {
  const value = isSet(formData?.[valueField], "");
  const showWhenValue = formData?.[showWhenField];
  const isChecked = Array.isArray(showWhenValue)
    ? showWhenValue.length > 0
    : typeof showWhenValue === "string"
      ? showWhenValue.trim() !== ""
      : !!showWhenValue;

  if (!isChecked || !value) return null;

  return (
    <div className={col}>
      <div className="mb-2 px-2">
        <span className="text-dark">
          {labelPrefix}: <strong>{value}</strong>
        </span>
      </div>
    </div>
  );
};

export default InlineValueText;
